import apiTruckerRecommendationBffService from 'config/truckerRecommendationBffService';
import { IGetTruckerTypeReturn } from 'services/trucker';

export const fetchTruckersRecommendedList = (id: string, radius: number): Promise<IGetTruckerTypeReturn> =>
  apiTruckerRecommendationBffService.get(`/freights/${id}/truckers-recommendation?radius=${radius}`);

export const fetchTruckersRecommendedPage = (
  id: string,
  radius: number,
  page: number
): Promise<IGetTruckerTypeReturn> =>
  apiTruckerRecommendationBffService.get(`/freights/${id}/truckers-recommendation?radius=${radius}&page=${page}`);
